import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import { estateEnterInfoSelector, showSaleConfirmSelector } from "@/domains/estate/slice";
import useShowEnterModal from "@/domains/estate/hooks/useShowEnterModal.ts";
import EstateEnterModalContainer from "@/domains/estate/containers/modals/EstateEnterModalContainer";
import EstateSaleConfirmModalContainer from "@/domains/estate/containers/modals/EstateSaleConfirmModalContainer";
import EstateSaleModalContainer from "@/domains/estate/containers/modals/EstateSaleModalContainer";

export default function EstateModalsContainer() {
  const estate = useAppSelector(estateEnterInfoSelector);
  const showSaleConfirm = useAppSelector(showSaleConfirmSelector);
  useShowEnterModal();

  const onClose = () => {
    GameMpProvider.closeCurrentInterface(true);
  };

  if (estate) {
    if (estate.isSale) {
      if (showSaleConfirm) {
        return <EstateSaleConfirmModalContainer />;
      }
      return <EstateSaleModalContainer onClose={onClose} />;
    }
    return <EstateEnterModalContainer onClose={onClose} />;
  }
}
